/* eslint-disable @typescript-eslint/no-explicit-any */
export const convertArrayToObjectByKey = <T extends Record<string, any>>(array: T[], key: keyof T): Record<string, T> => {
  return array.reduce((acc: Record<string, T>, element: T) => {
    acc[element[key] as unknown as string] = element;
    return acc;
  }, {});
};
